import React from 'react';

//redes
import behance from '../Images/footer/4.png';
import face from '../Images/footer/3.png';
import insta from '../Images/footer/2.png';
import whats from '../Images/footer/1.png';
import footer from '../Images/footer.png';


const Footer = () => {

    return (
        <footer className="page-footer" style={{background:"#101014", paddingBottom:"20px"}}>
            <div className='contenedor_footer'>
                <div className="row paddingLeftDesktop">
                    <div className="col s12 m12 l3" style={{marginBottom:"20px"}}>
                        <div className='col s12 m12' style={{display:"flex", justifyContent:"center"}}>
                            <img src={footer} alt="Software Over" style={{width:"270px", marginTop:"20px"}}/>
                        </div>
                    </div>

                    <div className="col s12 m12 l9 center_movil">
                        <div className='col s12 m4 l4' style={{display:"flex", justifyContent:"center", flexDirection:"column"}}>
                            <p className='titulo-footer'>Inicio</p>
                            <a className='texto-footer' href="/servicio/pagina-web" style={{color:"white"}}>Páginas web</a>
                            <a className='texto-footer' href="/servicio/aplicacion-movil" style={{color:"white"}}>Aplicaciones</a>
                            <a className='texto-footer' href="/servicio/sistemas-empresariales" style={{color:"white"}}>Sistemas empresariales</a>
                        </div>

                        <div className='col s12 m4 l4 center_movil'
                            style={{display:"flex", justifyContent:"center", flexDirection:"column"}}>
                            <p className='titulo-footer'>Servicios</p>
                            <a className='texto-footer' href="/servicio/branding" style={{color:"white"}}>Branding</a>
                            <a className='texto-footer' href="/servicio/google-ads" style={{color:"white"}}>Google ADS</a>
                            <a className='texto-footer' href="/terminos-y-condiciones" style={{color:"white"}}>Aviso de privacidad</a>
                        </div>

                        <div className='col l4 hide-on-med-and-down center_movil'style={{display:"flex", justifyContent:"center", flexDirection:"column", flexWrap:"wrap"}}>
                            <p className='titulo-footer'>Contacto</p>
                            <a target="_blank" rel="noopener noreferrer" className='texto-footer' href="tel:+523333702640" style={{color:"white"}}>+52 33 3370 2640</a>
                            <a target="_blank" rel="noopener noreferrer" className='texto-footer' href="mailto:softwareover@gmail.com?Subject=¡Hola buen día! &body=¡Hola buen día!%0E¿Me podrías dar más información?" style={{color:"white"}}>softwareover@gmail.com</a>

                            <div className='center_movil' style={{display:"flex", alignItems:"center", marginTop:"10px"}}>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/SoftwareOver" style={{margin:"5px"}}>
                                    <img src={face} alt="Pagina Facebook SOftware Over" style={{width:"30px"}} />
                                </a>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/softwareover/" style={{margin:"5px"}}>
                                    <img src={insta} alt="Perfil Instagram Software Over" style={{width:"30px"}} />
                                </a>
                                <a target="_blank" rel="noopener noreferrer" href="https://wa.me/523333702640?text=¡Hola buen día! ¿Me podrías dar información?" style={{margin:"5px"}}>
                                    <img src={whats} alt="Numero WhatsApp Software Over" style={{width:"30px"}} />
                                </a>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.behance.net/softwareover1" style={{margin:"5px"}}>
                                    <img src={behance} alt="Behance Software Over" style={{width:"30px"}} />
                                </a>
                            </div>
                        </div>


                        {/* Inicio Vistas Móvil y Tablet */}
                        <div className='col s12 m4 hide-on-large-only center_movil'style={{display:"flex", justifyContent:"center", flexDirection:"column", flexWrap:"wrap"}}>
                            <p className='titulo-footer'>Contacto</p>
                            <a className='texto-footer' href="tel:+523333702640" style={{color:"white"}}>
                                +52 33 3370 2640
                            </a>
                            <a className='texto-footer' href="mailto:softwareover@gmail.com?Subject=¡Hola buen día! &body=¡Hola buen día!%0E¿Me podrías dar más información?" style={{color:"white"}}>
                                softwareover@gmail.com
                            </a>
                        </div>
                        <div className='col s12 m12 show-on-small hide-on-large-only center_movil'style={{display:"flex", justifyContent:"center", flexDirection:"column", flexWrap:"wrap", alignItems:"center"}}>
                            <p className='titulo-footer'>Siguenos</p>
                            
                            <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                <a href="https://www.facebook.com/SoftwareOver" style={{margin:"5px"}}>
                                    <img src={face} alt="Pagina Facebook SOftware Over" style={{width:"40px"}} />
                                </a>
                                <a href="https://www.instagram.com/softwareover/" style={{margin:"5px"}}>
                                    <img src={insta} alt="Perfil Instagram Software Over" style={{width:"40px"}} />
                                </a>
                                <a href="https://wa.me/523333702640?text=¡Hola buen día! ¿Me podrías dar información?" style={{margin:"5px"}}>
                                    <img src={whats} alt="Numero WhatsApp Software Over" style={{width:"40px"}} />
                                </a>
                                <a href="https://www.behance.net/softwareover1" style={{margin:"5px"}}>
                                    <img src={behance} alt="Behance Software Over" style={{width:"40px"}} />
                                </a>
                            </div>
                        </div>
                        {/* Fin Vistas Móvil y Tablet */}
                    </div>
                </div>
                <div className='linea-hor'></div>
                <p className='texto-footer-2'> © Software Over {new Date().getFullYear()} All rights reserved </p>
            </div>
        </footer>
    )
}

export default Footer;